import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { HierarchyEntity } from 'app/modules/settings/interfaces/hierarchy-data';
import { ClientIntegrationSource, Employee } from '../interfaces/client-data';

export module EditRequirementsValidators {
    let originalSource: string = '';
    export function SourceNameUnique(sources: ClientIntegrationSource[]): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            // Get the original source by checking the field when it has not been touched
            if (control.pristine == true) {
                originalSource = control.value;
            }

            if (!control || !control.value) {
                return null;
            }

            let newSourceName = control.value;
            let existingSource = sources?.find((source) => source.description == newSourceName);
            if (newSourceName && existingSource && existingSource.description != originalSource) {
                return { notUnique: true };
            }
        };
    }

    export function ZeroPadding(): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control || !control.value) {
                return null;
            }

            if(control.value == 0) {
                return { hasZero: true };
            }
        };
    }
    
    export function ZeroPaddingEntityRule(employees: Employee[], entities: HierarchyEntity[]): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control || !control.value) {
                return null;
            }

            if((employees?.length > 1 || entities?.length > 1) && control.value == 'Yes') {
                return { zeroPaddingEntityRule: true };
            }
        };
    }
}
